(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["havana-editorial-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviews = [
      {
        "quote": "I’ve been searching for a great pillow for years. So many different kids and nothing ever satisfies me. I was at a hotel with my family and I slept so well, so I checked the pillow brand and it was Havana. I immediately purchased their pillow and I’ve been so comfy ever since. The pillow search is over. My husband is trying to steal this pillow from me and I told him to buy his own, but they are sold out! Lol",
        "author": "Peter",
        "rating": 5,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "Very soft and doesn't trap heat. Perfect for sleep!",
        "author": "Thomas C.",
        "rating": 5,
        "verified": true,
        "product": "Bilbao Pillowcases — Set of 2",
        "url": "https://www.havana1960.com/products/bilbao-pillowcase"
      },
      {
        "quote": "It does keep me cooler, but I thought it would be softer.",
        "author": "Tiffany H.",
        "rating": 4,
        "verified": true,
        "product": "Catalina Sheets & Pillowcase",
        "url": "https://www.havana1960.com/products/catalina-bed-set"
      },
      {
        "quote": "I was so excited about purchasing these pool towels.  They looked like the ones we used at the Sagamore Resort in Bolton Landing, NY.  The quality is decent but not what I was expecting.  The towels I purchased are thinner and smaller than the ones at the resort. We will use them and enjoy them but they are a bit skimpier that what I was expecting.  I gave a 4 star because I know this is a good company.",
        "author": "Susan S.",
        "rating": 4,
        "verified": true,
        "product": "Sailor Stripe Blue 4 Pack",
        "url": "https://www.havana1960.com/products/sailor-stripe-blue-4-pack"
      },
      {
        "quote": "Amazing",
        "author": "Shannon H.",
        "rating": 5,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "Best pillows ever!",
        "author": "Bonnie A.",
        "rating": 5,
        "verified": true,
        "product": "View all reviews",
        "url": "https://www.havana1960.com/pages/reviews"
      },
      {
        "quote": "I love this pillow soooo much!",
        "author": "Bonnie A.",
        "rating": 5,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "Havana 1960 makes the best towels. I have enjoyed using them at both at my home and at several hotels. I do not use any other brand.",
        "author": "Noni F.",
        "rating": 5,
        "verified": true,
        "product": "View all reviews",
        "url": "https://www.havana1960.com/pages/reviews"
      },
      {
        "quote": "These are truly excellent towels - both highly absorbent and lightweight. I love them an use them even at home. ",
        "author": "Noni F.",
        "rating": 5,
        "verified": false,
        "product": "Holiday Stripe Beach and Pool Towel",
        "url": "https://www.havana1960.com/products/holiday-stripe-pool-towel"
      },
      {
        "quote": "after sleeping in these at Great Wolfe Lodge I ordered some. Love them. ",
        "author": "christy g.",
        "rating": 5,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "Nice generous size. Absorbent without being too thick/heavy",
        "author": "Brenda A.",
        "rating": 5,
        "verified": true,
        "product": "Holiday Yellow 4 Pack",
        "url": "https://www.havana1960.com/products/holiday-yellow-4-pack"
      },
      {
        "quote": "They were just as I expected! I was introduced to these at Great Wolf Lodge",
        "author": "Toni B.",
        "rating": 5,
        "verified": true,
        "product": "Mariel Wash Cloth",
        "url": "https://www.havana1960.com/products/mariel-wash-cloth"
      },
      {
        "quote": "I got the 20x30 pillow - firm. It’s comfortable but not firm enough, at least not as firm as the same pillow I slept on at Great Wolf Lodge.",
        "author": "Ruben B.",
        "rating": 4,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "I purchased this pillow after a recent stay at Great Wolf Lodge. As soon as I got home I looked up who supplies their pillows. This pillow is so incredibly soft and comfortable. I feel so relaxed like I'm back on vacation. Thank you for such a quality product. ",
        "author": "CDUB",
        "rating": 5,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "Ordered without any issues",
        "author": "Teresa S.",
        "rating": 5,
        "verified": true,
        "product": "View all reviews",
        "url": "https://www.havana1960.com/pages/reviews"
      },
      {
        "quote": "Great quality. Luxuriously soft and absorbent. ",
        "author": "Teresa S.",
        "rating": 5,
        "verified": true,
        "product": "Seville Bath Towel",
        "url": "https://www.havana1960.com/products/bath-towel"
      },
      {
        "quote": "Best towels and wash clothes ",
        "author": "AG",
        "rating": 5,
        "verified": true,
        "product": "Palma Bath Towels & Tub Mat",
        "url": "https://www.havana1960.com/products/palma-bath-set"
      },
      {
        "quote": "Buy them",
        "author": "Tim E.",
        "rating": 5,
        "verified": true,
        "product": "Barcelona Pillowcase set",
        "url": "https://www.havana1960.com/products/eucalyptus-sateen-luxury-hotel-pillowcase"
      },
      {
        "quote": "Rated 4 out of 5 stars.",
        "author": "Cathy C.",
        "rating": 4,
        "verified": true,
        "product": "Seville Bath Towel",
        "url": "https://www.havana1960.com/products/bath-towel"
      },
      {
        "quote": "I love them",
        "author": "Cathy C.",
        "rating": 5,
        "verified": true,
        "product": "Palma Bath Towels & Tub Mat",
        "url": "https://www.havana1960.com/products/palma-bath-set"
      },
      {
        "quote": "Great product",
        "author": "Tim E.",
        "rating": 5,
        "verified": true,
        "product": "View all reviews",
        "url": "https://www.havana1960.com/pages/reviews"
      },
      {
        "quote": "Too thing for me ",
        "author": "Elibet B.",
        "rating": 2,
        "verified": true,
        "product": "Mariel Bath Towel",
        "url": "https://www.havana1960.com/products/copy-of-seville-bath-towel"
      },
      {
        "quote": "Great Towels",
        "author": "Tim E.",
        "rating": 5,
        "verified": true,
        "product": "Seville Bath Towel",
        "url": "https://www.havana1960.com/products/bath-towel"
      },
      {
        "quote": "I bought this pillow because Great wolf lodge had it. I'm pleased with my pillow.",
        "author": "Staci O.",
        "rating": 5,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "Found a Havana towel while clearing out a family member’s home.  Started using it as my daily bath towel, and love its absorbency. Have washed it many times over the last year and it’s as good as the day i found it!",
        "author": "Pat Y.",
        "rating": 5,
        "verified": false,
        "product": "Ocean Stripe Pool Towel",
        "url": "https://www.havana1960.com/products/ocean-stripe-pool-towel-1"
      },
      {
        "quote": "After sleeping at a Great Wolf Lodge, I ran to buy these pillows.  I think I bought the soft ones but should have bought the full ones.  They are nice pillows though.",
        "author": "German E.",
        "rating": 3,
        "verified": true,
        "product": "Pillow 20 × 30",
        "url": "https://www.havana1960.com/products/pillow-20x30"
      },
      {
        "quote": "using them for years",
        "author": "Caryl B.",
        "rating": 5,
        "verified": false,
        "product": "Holiday Stripe Beach and Pool Towel",
        "url": "https://www.havana1960.com/products/holiday-stripe-pool-towel"
      },
      {
        "quote": "The towels I purchased from HAVANA 1960 are of Excellent quality, lasting and unique !!!!!",
        "author": "Tom H.",
        "rating": 5,
        "verified": false,
        "product": "Sailor Stripe Towel",
        "url": "https://www.havana1960.com/products/sailor-stripe-pool-towel"
      },
      {
        "quote": "Love these towels for the pool. Quality material. Well made. Great company to do business with. Highly recommend.",
        "author": "Beth H.",
        "rating": 5,
        "verified": false,
        "product": "Ocean Stripe Pool Towel",
        "url": "https://www.havana1960.com/products/ocean-stripe-pool-towel-1"
      },
      {
        "quote": "I love these towels. Nice to do business with a brand that delivers. Worth every penny.",
        "author": "Beth H.",
        "rating": 5,
        "verified": false,
        "product": "Galia",
        "url": "https://www.havana1960.com/products/peshtemal-beach-towel-lightweight-100-cotton-72-l-x-40-w-galia"
      },
      {
        "quote": "I haven’t received my product as yet but have used a towel from this company which led to me to seek them out to see if I could purchase some of their amazing towels & what I discovered is that their customer service is just as stellar. I called the ph # I found on the website from the tag (on the towel) and left a msg. Rich called back within about a minute and helped me for some time by answering questions & providing the information I needed & then had Andrew call who spent at least the next 30-40 minutes texting and responding to my inquiries & providing me Photo examples & options. I’m am amazed at the kindness, the patent and the attentive & thorough customer care!!! I celebrate it because as we all know it just doesn’t happen in this society as much as we would like! So to all out there… excellent communication & product! Give this company your business Bc they earned it!! And in my opinion… they deserve it! Looking forward to my shipment & even thinking I may use some as gifts! Feeling grateful! No kidding! A good kitchen towel is hard to find!!",
        "author": "Sharon",
        "rating": 5,
        "verified": false,
        "product": "Club Hand Towel",
        "url": "https://www.havana1960.com/products/club-hand-towel"
      },
      {
        "quote": "I bought 4 a few years ago. That didn’t have them last year. I bought a couple more kinds from different brands and I didn’t like them. I was so glad these returned!",
        "author": "Darcy K.",
        "rating": 5,
        "verified": false,
        "product": "Surfside",
        "url": "https://www.havana1960.com/products/surfside"
      },
      {
        "quote": "I bought this BATIK Turkish towel and it was amazing. felt so soft on my skin and very absorbent. would recommend and will be buying again.",
        "author": "Andrew",
        "rating": 5,
        "verified": false,
        "product": "Batik",
        "url": "https://www.havana1960.com/products/beach-towel-lightweight-100-cotton-72-l-x-40-w-batik"
      }
    ];

    const initializeGuestbooks = (root) => {
      root.querySelectorAll('[data-hz-guestbook]').forEach((section) => {
        if (section.dataset.hzReviewReady === 'true') return;
        section.dataset.hzReviewReady = 'true';

        const reviewCard = section.querySelector('.hz-guestbook__review');
        const quote = section.querySelector('[data-hz-review-quote]');
        const author = section.querySelector('[data-hz-review-author]');
        const product = section.querySelector('[data-hz-review-product]');
        const current = section.querySelector('[data-hz-review-current]');
        const rating = section.querySelector('[data-hz-review-rating]');
        const stars = section.querySelector('[data-hz-review-stars]');
        const ratingLabel = section.querySelector('[data-hz-review-rating-label]');
        const verification = section.querySelector('[data-hz-review-verification]');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let reviewIndex = 0;
        let paused = false;

        const showReview = (index) => {
          reviewIndex = (index + reviews.length) % reviews.length;
          const review = reviews[reviewIndex];
          reviewCard.classList.add('is-changing');

          window.setTimeout(() => {
            const excerpt = review.quote.length > 260 ? `${review.quote.slice(0, 257).trim()}…` : review.quote;
            const reviewLabel = review.verified ? section.dataset.verifiedReview : section.dataset.customerReview;
            quote.textContent = excerpt;
            author.textContent = review.author;
            product.textContent = review.product;
            product.href = review.url;
            stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
            ratingLabel.textContent = `${review.rating.toFixed(1)} · ${reviewLabel}`;
            rating.setAttribute('aria-label', section.dataset.ratingAria.replace('__RATING__', String(review.rating)));
            verification.textContent = review.verified ? section.dataset.verifiedBuyer : section.dataset.customerReview;
            verification.classList.toggle('is-unverified', !review.verified);
            current.textContent = String(reviewIndex + 1).padStart(2, '0');
            reviewCard.classList.remove('is-changing');
          }, 220);
        };

        section.addEventListener('mouseenter', () => { paused = true; });
        section.addEventListener('mouseleave', () => { paused = false; });
        section.addEventListener('focusin', () => { paused = true; });
        section.addEventListener('focusout', () => { paused = false; });

        if (!reduceMotion) {
          window.setInterval(() => {
            if (!paused) showReview(reviewIndex + 1);
          }, 6500);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeGuestbooks(document));
    } else {
      initializeGuestbooks(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeGuestbooks(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-housekeeping-checklist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotel-housekeeping-checklist')) {
    customElements.define('hotel-housekeeping-checklist', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.copy = JSON.parse(this.querySelector('[data-tool-copy]').textContent);
        this.customTasks = [];
        this.form = this.querySelector('[data-setup-form]');
        this.checklist = this.querySelector('[data-checklist]');
        this.status = this.querySelector('[data-status]');
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          if (!this.selectedRoutines().length) {
            this.status.textContent = this.copy.labels.empty;
            return;
          }
          this.status.textContent = this.copy.labels.updated;
          this.render();
          this.track('housekeeping_checklist_generated');
          this.querySelector('.hh-folio').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        this.querySelector('[data-reset-setup]').addEventListener('click', () => {
          this.form.reset();
          this.querySelector('[data-property-name]').value = this.copy.labels.propertyFallback;
          this.querySelector('[data-room-count]').value = 48;
          this.customTasks = [];
          this.status.textContent = this.copy.labels.restored;
          this.render();
        });
        this.querySelector('[data-add-task-form]').addEventListener('submit', event => {
          event.preventDefault();
          const input = this.querySelector('[data-custom-task]');
          if (!input.value.trim()) return;
          this.customTasks.push({ id: Date.now(), group: this.querySelector('[data-custom-section]').value, text: input.value.trim() });
          input.value = '';
          this.status.textContent = this.copy.labels.added;
          this.render();
        });
        this.querySelector('[data-clear]').addEventListener('click', () => {
          this.checklist.querySelectorAll('input:checked').forEach(input => {
            input.checked = false;
            input.closest('.hh-task').classList.remove('is-complete');
          });
          this.status.textContent = this.copy.labels.cleared;
          this.updateProgress();
        });
        this.querySelector('[data-print]').addEventListener('click', () => {
          this.track('housekeeping_checklist_printed');
          this.dispatchEvent(new CustomEvent('havana:print-tool', { bubbles: true }));
        });
        this.querySelector('[data-download]').addEventListener('click', () => this.download());
        this.querySelector('[data-wholesale-link]').addEventListener('click', () => this.track('hospitality_wholesale_clicked'));
        this.querySelectorAll('[data-property-name],[data-property-type],[data-room-count],input[name^="routine-"]').forEach(input => input.addEventListener('change', () => this.updateMeta()));
        this.render();
      }

      selectedRoutines() {
        return Array.from(this.querySelectorAll('input[name^="routine-"]:checked')).map(input => input.value);
      }

      escape(value) {
        const element = document.createElement('div');
        element.textContent = value;
        return element.innerHTML;
      }

      render() {
        const modes = this.selectedRoutines();
        this.checklist.innerHTML = this.copy.groups.map(group => {
          const active = group.types.some(type => modes.includes(type));
          const standard = group.tasks.filter(task => task.types.some(type => modes.includes(type)));
          const tasks = standard.map((task, index) => `<li class="hh-task"><input id="hh-${this.dataset.sectionId}-${group.id}-${index}" type="checkbox"><label for="hh-${this.dataset.sectionId}-${group.id}-${index}">${task.text}</label></li>`).join('');
          const custom = this.customTasks.filter(task => task.group === group.id).map(task => `<li class="hh-task is-custom"><input id="hh-custom-${task.id}" type="checkbox"><label for="hh-custom-${task.id}">${this.escape(task.text)}</label><button class="hh-remove" type="button" data-remove="${task.id}">${this.copy.labels.remove}</button></li>`).join('');
          return `<section class="hh-group" data-group="${group.id}" ${active || custom ? '' : 'hidden'}><div class="hh-group__head"><h4>${group.title}</h4><span>${standard.length} ${this.copy.labels.standard}</span></div><ul class="hh-tasks">${tasks}${custom}</ul></section>`;
        }).join('');
        this.checklist.querySelectorAll('input[type="checkbox"]').forEach(input => input.addEventListener('change', () => {
          input.closest('.hh-task').classList.toggle('is-complete', input.checked);
          this.updateProgress();
        }));
        this.checklist.querySelectorAll('[data-remove]').forEach(button => button.addEventListener('click', () => {
          this.customTasks = this.customTasks.filter(task => String(task.id) !== button.dataset.remove);
          this.render();
        }));
        this.updateMeta();
        this.updateProgress();
      }

      updateMeta() {
        const name = this.querySelector('[data-property-name]').value.trim() || this.copy.labels.propertyFallback;
        const type = this.querySelector('[data-property-type]').value;
        const rooms = Math.max(1, Number(this.querySelector('[data-room-count]').value) || 1);
        this.querySelector('[data-property-output]').textContent = name;
        this.querySelector('[data-type-output]').textContent = `${type} · ${rooms} ${rooms === 1 ? this.copy.labels.roomSingular : this.copy.labels.roomPlural}`;
        const labels = this.selectedRoutines().map(value => this.copy.routineLabels[value]);
        this.querySelector('[data-routine-output]').textContent = labels.length ? labels.join(' · ') : this.copy.labels.empty;
      }

      updateProgress() {
        const tasks = Array.from(this.checklist.querySelectorAll('.hh-task input'));
        const done = tasks.filter(input => input.checked).length;
        this.querySelector('[data-progress-output]').textContent = `${done} of ${tasks.length} tasks complete`;
        this.querySelector('[data-progress-bar]').style.width = tasks.length ? `${done / tasks.length * 100}%` : '0%';
      }

      download() {
        const title = `${this.copy.labels.downloadTitle} — ${this.querySelector('[data-property-output]').textContent}`;
        const lines = [title, this.querySelector('[data-type-output]').textContent, ''];
        this.copy.groups.forEach(group => {
          const section = this.checklist.querySelector(`[data-group="${group.id}"]`);
          if (!section || section.hidden) return;
          lines.push(group.title.toUpperCase());
          section.querySelectorAll('.hh-task').forEach(item => lines.push(`[${item.querySelector('input').checked ? 'x' : ' '}] ${item.querySelector('label').textContent}`));
          lines.push('');
        });
        const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'hotel-housekeeping-checklist.txt';
        link.click();
        URL.revokeObjectURL(link.href);
        this.status.textContent = this.copy.labels.downloaded;
        this.track('housekeeping_checklist_downloaded');
      }

      track(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, tool_name: 'hotel_housekeeping_checklist', routines: this.selectedRoutines().join(',') });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-housekeeping-staffing-calculator"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('hotel-housekeeping-staffing-calculator'))customElements.define('hotel-housekeeping-staffing-calculator',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.form=this.querySelector('[data-form]');this.form.addEventListener('input',()=>this.calculate());this.form.addEventListener('submit',e=>{e.preventDefault();this.calculate();this.querySelector('[data-status]').textContent='Staffing plan updated.';window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'housekeeping_staffing_calculated',tool_name:'hotel_housekeeping_staffing_calculator'})});this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.querySelector('[data-status]').textContent='Sample property restored.';this.calculate()});this.querySelector('[data-print]').addEventListener('click',()=>{this.dispatchEvent(new CustomEvent('havana:print-tool', { bubbles: true }));});this.calculate()}v(n){return Math.max(0,Number(this.querySelector(`[data-input="${n}"]`).value)||0)}set(n,v){this.querySelector(`[data-${n}]`).textContent=v}money(n){return n.toLocaleString('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0})}fte(n,workdays,relief){return n*7/Math.max(.5,workdays)*(1+relief)}calculate(){let rooms=Math.max(1,this.v('rooms')),occupancy=Math.min(100,this.v('occupancy'))/100,occupied=Math.round(rooms*occupancy),departureShare=Math.min(100,this.v('departureShare'))/100,checkouts=Math.round(occupied*departureShare),stayovers=Math.max(0,occupied-checkouts),serviced=Math.round(stayovers*Math.min(100,this.v('stayoverService'))/100),deep=Math.round(this.v('deepCount')),roomMinutes=checkouts*this.v('checkoutMinutes')+serviced*this.v('stayoverMinutes')+deep*this.v('deepMinutes'),shiftHours=Math.max(1,this.v('shiftHours')),productive=Math.max(30,shiftHours*60-this.v('nonRoomMinutes')),attendants=Math.max(roomMinutes>0?1:0,Math.ceil(roomMinutes/productive)),publicHours=this.v('publicHours'),laundryHours=this.v('laundryHours'),publicStaff=Math.ceil(publicHours/shiftHours),laundryStaff=Math.ceil(laundryHours/shiftHours),ratio=Math.max(1,this.v('supervisorRatio')),supervisors=Math.max(attendants>0?1:0,Math.ceil(attendants/ratio)),daily=attendants+publicStaff+laundryStaff+supervisors,workdays=Math.max(.5,this.v('workdays')),relief=Math.min(100,this.v('relief'))/100,attFte=this.fte(attendants,workdays,relief),publicFte=this.fte(publicStaff,workdays,relief),laundryFte=this.fte(laundryStaff,workdays,relief),supervisorFte=this.fte(supervisors,workdays,relief),totalFte=attFte+publicFte+laundryFte+supervisorFte,utilization=attendants?roomMinutes/(attendants*productive):0,roomsServiced=checkouts+serviced,dailyPaidHours=attendants*shiftHours+publicHours+laundryHours+supervisors*shiftHours,dailyCost=dailyPaidHours*this.v('wage');this.set('hero-attendants',attendants);this.set('occupied',occupied.toLocaleString('en-US'));this.set('checkouts',checkouts.toLocaleString('en-US'));this.set('stayovers',serviced.toLocaleString('en-US'));this.set('deep',deep.toLocaleString('en-US'));this.set('room-hours',`${(roomMinutes/60).toFixed(1)} hr`);this.set('attendants',attendants);this.set('public',publicStaff);this.set('laundry',laundryStaff);this.set('supervisors',supervisors);this.set('attendant-fte',`${attFte.toFixed(1)} FTE`);this.set('public-fte',`${publicFte.toFixed(1)} FTE`);this.set('laundry-fte',`${laundryFte.toFixed(1)} FTE`);this.set('supervisor-fte',`${supervisorFte.toFixed(1)} FTE`);this.set('daily-total',daily);this.set('total-fte',`${totalFte.toFixed(1)} FTE`);this.set('rooms-per-attendant',attendants?(roomsServiced/attendants).toFixed(1):'0');this.set('utilization',`${Math.round(utilization*100)}%`);this.set('daily-cost',this.money(dailyCost));this.set('annual-cost',this.money(dailyCost*365));this.set('ra-detail',`${productive.toLocaleString('en-US')} productive minutes each`);this.set('public-detail',`${publicHours.toFixed(1)} scheduled hours`);this.set('laundry-detail',`${laundryHours.toFixed(1)} scheduled hours`);this.set('supervisor-detail',`1 per ${ratio.toLocaleString('en-US')} room attendants`);let alert=this.querySelector('[data-alert]');if(utilization>.92){alert.textContent='Capacity check: the room assignment uses more than 92% of available productive time. Consider another attendant or a larger contingency before publishing the schedule.';alert.classList.add('is-visible')}else if(utilization<.65&&attendants>1){alert.textContent='Capacity check: the modeled room assignment uses less than 65% of room-attendant capacity. Review the room forecast, timing assumptions and non-room duties before reducing staff.';alert.classList.add('is-visible')}else{alert.textContent='';alert.classList.remove('is-visible')}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-laundry-cost-calculator"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('hotel-laundry-cost-calculator'))customElements.define('hotel-laundry-cost-calculator',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.c=JSON.parse(this.querySelector('[data-copy]').textContent);this.form=this.querySelector('[data-form]');this.form.addEventListener('input',()=>this.calculate());this.form.addEventListener('submit',e=>{e.preventDefault();this.calculate();this.querySelector('[data-status]').textContent=this.c.updated;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'laundry_cost_calculated',tool_name:'hotel_laundry_cost_calculator'})});this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.querySelector('[data-status]').textContent=this.c.restored;this.calculate()});this.querySelector('[data-print]').addEventListener('click',()=>{this.dispatchEvent(new CustomEvent('havana:print-tool', { bubbles: true }));});this.calculate()}v(n){return Math.max(0,Number(this.querySelector(`[data-input="${n}"]`).value)||0)}money(n,d=0){return n.toLocaleString('en-US',{style:'currency',currency:'USD',minimumFractionDigits:d,maximumFractionDigits:d})}num(n){return Math.ceil(n).toLocaleString('en-US')}calculate(){let rooms=Math.max(1,this.v('rooms')),occ=Math.min(100,this.v('occupancy'))/100,days=Math.max(1,this.v('days')),nights=rooms*occ*days,lbs=nights*this.v('pounds'),loads=Math.ceil(lbs/Math.max(1,this.v('capacity'))),labor=this.v('laborHours')*this.v('wage')*days,load=loads*(this.v('utilities')+this.v('chemicals')),fixed=this.v('fixed'),inside=labor+load+fixed,vendor=lbs*this.v('vendorRate'),pickup=this.v('pickup'),outside=vendor+pickup,diff=Math.abs(inside-outside),insideLower=inside<outside;this.querySelector('[data-difference]').textContent=this.money(diff*12);this.querySelector('[data-lower]').textContent=inside===outside?this.c.equal:(insideLower?this.c.inhouseLower:this.c.outsourceLower);this.querySelector('[data-room-nights]').textContent=`${this.num(nights)} ${this.c.roomNights}`;this.querySelector('[data-volume-meta]').textContent=`${this.num(lbs)} lb · ${this.num(loads)} ${this.c.loadsMonth}`;this.querySelector('[data-monthly-pounds]').textContent=`${this.num(lbs)} lb`;this.querySelector('[data-monthly-loads]').textContent=this.num(loads);this.querySelector('[data-pounds-metric]').textContent=`${this.v('pounds').toFixed(1)} lb`;[['labor-cost',labor],['load-cost',load],['fixed-cost',fixed],['inhouse-monthly',inside],['inhouse-annual',inside*12],['vendor-cost',vendor],['pickup-cost',pickup],['outsource-total',outside],['outsource-monthly',outside],['outsource-annual',outside*12],['monthly-difference',diff]].forEach(([k,n])=>this.querySelector(`[data-${k}]`).textContent=this.money(n));this.querySelector('[data-inhouse-per-room]').textContent=this.money(inside/Math.max(1,nights),2);this.querySelector('[data-outsource-per-room]').textContent=this.money(outside/Math.max(1,nights),2);this.querySelector('[data-inhouse-option]').classList.toggle('hc-winner',insideLower);this.querySelector('[data-outsource-option]').classList.toggle('hc-winner',!insideLower&&inside!==outside)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-linen-order-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotel-linen-order-calculator')) {
    customElements.define('hotel-linen-order-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
        this.form = this.querySelector('[data-calculator-form]');
        this.status = this.querySelector('[data-status]');
        this.poolToggle = this.querySelector('[data-pool-toggle]');
        this.form.addEventListener('input', () => this.calculate());
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.calculate();
          this.status.textContent = this.copy.labels.updated;
          this.track('linen_order_calculated');
          this.querySelector('.hl-folio').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        this.poolToggle.addEventListener('change', () => {
          this.querySelector('[data-pool-fields]').hidden = !this.poolToggle.checked;
          this.calculate();
        });
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.form.reset();
          this.querySelector('[data-pool-fields]').hidden = true;
          this.status.textContent = this.copy.labels.restored;
          this.calculate();
        });
        this.querySelector('[data-print]').addEventListener('click', () => {
          this.track('linen_order_printed');
          this.dispatchEvent(new CustomEvent('havana:print-tool', { bubbles: true }));
        });
        this.querySelector('[data-download]').addEventListener('click', () => this.download());
        this.querySelector('[data-wholesale]').addEventListener('click', () => this.track('hospitality_wholesale_clicked'));
        this.calculate();
      }

      value(name) {
        return Math.max(0, Number(this.querySelector(`[data-input="${name}"]`).value) || 0);
      }

      format(number) {
        return Math.ceil(number).toLocaleString('en-US');
      }

      roundQuantity(number) {
        return Math.ceil(Number(number.toFixed(10)));
      }

      calculate() {
        const par = this.value('par');
        const reserve = this.value('reserve') / 100;
        const factor = par * (1 + reserve);
        const methods = {
          'fitted-flat': { fitted: 1, flat: 1 },
          'two-flat': { fitted: 0, flat: 2 },
          'fitted-two-flat': { fitted: 1, flat: 2 },
          'three-flat': { fitted: 0, flat: 3 }
        };
        const method = methods[this.querySelector('[data-input="method"]').value];
        const beds = { King: this.value('king'), Queen: this.value('queen'), Full: this.value('full'), Twin: this.value('twin') };
        const rooms = this.value('rooms');
        const cases = this.value('cases');
        const rows = [];
        Object.entries(beds).forEach(([size, count]) => {
          const label = this.copy.sizes[size];
          if (method.fitted) rows.push({ category: this.copy.labels.bed, item: `${label} ${this.copy.labels.fitted}`, basis: `${count} ${label.toLowerCase()} ${this.copy.labels.beds} × ${method.fitted}`, base: count * method.fitted });
          if (method.flat) rows.push({ category: this.copy.labels.bed, item: `${label} ${this.copy.labels.flat}`, basis: `${count} ${label.toLowerCase()} ${this.copy.labels.beds} × ${method.flat}`, base: count * method.flat });
        });
        const kingCases = beds.King * cases;
        const standardCases = (beds.Queen + beds.Full + beds.Twin) * cases;
        if (kingCases) rows.push({ category: this.copy.labels.bed, item: this.copy.labels.kingCases, basis: `${beds.King} ${this.copy.labels.beds} × ${cases}`, base: kingCases });
        if (standardCases) rows.push({ category: this.copy.labels.bed, item: this.copy.labels.standardCases, basis: `${beds.Queen + beds.Full + beds.Twin} ${this.copy.labels.beds} × ${cases}`, base: standardCases });
        [['bathTowels','bath'],['handTowels','hand'],['washcloths','wash'],['bathMats','mats']].forEach(([label, input]) => rows.push({ category: this.copy.labels.bath, item: this.copy.labels[label], basis: `${rooms} ${this.copy.labels.rooms} × ${this.value(input)}`, base: rooms * this.value(input) }));
        if (this.poolToggle.checked) rows.push({ category: this.copy.labels.pool, item: this.copy.labels.poolTowels, basis: `${this.value('poolCapacity')} ${this.copy.labels.guests} × ${this.value('poolEach')}`, base: this.value('poolCapacity') * this.value('poolEach') });
        let category = '';
        let total = 0;
        this.querySelector('[data-results]').innerHTML = rows.map(row => {
          const order = this.roundQuantity(row.base * factor);
          total += order;
          const heading = row.category !== category ? `<tr class="hl-category"><td colspan="4">${row.category}</td></tr>` : '';
          category = row.category;
          return `${heading}<tr class="${order ? '' : 'hl-zero'}"><td>${row.item}</td><td>${row.basis}</td><td>${this.format(row.base)}</td><td>${this.format(order)}</td></tr>`;
        }).join('');
        const totalBeds = Object.values(beds).reduce((sum, number) => sum + number, 0);
        const property = this.querySelector('[data-property-name]').value.trim() || this.copy.labels.yourProperty;
        this.querySelector('[data-total]').textContent = this.format(total);
        this.querySelector('[data-property-output]').textContent = property;
        this.querySelector('[data-assumptions]').textContent = `${this.format(rooms)} ${this.copy.labels.rooms} · ${this.format(totalBeds)} ${this.copy.labels.beds} · ${par} PAR · ${Math.round(reserve * 100)}% reserve`;
        this.querySelector('[data-formula]').textContent = `${this.copy.labels.formulaStart} ${par} PAR × ${(1 + reserve).toFixed(2)} ${this.copy.labels.formulaEnd}`;
        this.rows = rows.map(row => ({ ...row, order: this.roundQuantity(row.base * factor) }));
      }

      download() {
        this.calculate();
        const lines = [[this.copy.labels.downloadTitle, this.querySelector('[data-property-output]').textContent], ['Item', 'Planning basis', '1 PAR', 'Recommended order'], ...this.rows.map(row => [row.item, row.basis, Math.ceil(row.base), row.order])];
        const csv = lines.map(row => row.map(cell => `"${String(cell).replaceAll('"', '""')}"`).join(',')).join('\n');
        const blob = new Blob([csv], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'hotel-linen-order.csv';
        link.click();
        URL.revokeObjectURL(link.href);
        this.status.textContent = this.copy.labels.downloaded;
        this.track('linen_order_downloaded');
      }

      track(event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, tool_name: 'hotel_linen_order_calculator', par_level: this.value('par') });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-linen-par-calculator"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('hotel-linen-par-calculator'))customElements.define('hotel-linen-par-calculator',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.c=JSON.parse(this.querySelector('[data-copy]').textContent);this.form=this.querySelector('[data-form]');this.form.addEventListener('input',()=>this.calculate());this.form.addEventListener('submit',e=>{e.preventDefault();let p=this.calculate();this.querySelector('[data-status]').textContent=this.c.updated;window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'linen_par_calculated',tool_name:'hotel_linen_par_calculator',recommended_par:p})});this.querySelector('[data-laundry]').addEventListener('change',e=>{this.querySelector('[data-input="turnaround"]').value=e.target.value==='offsite'?48:24;this.calculate()});this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.querySelector('[data-status]').textContent=this.c.restored;this.calculate()});this.querySelector('[data-print]').addEventListener('click',()=>{this.dispatchEvent(new CustomEvent('havana:print-tool', { bubbles: true }));});this.calculate()}v(n){return Math.max(0,Number(this.querySelector(`[data-input="${n}"]`).value)||0)}f(n){return Math.ceil(n).toLocaleString('en-US')}calculate(){let rooms=Math.max(1,this.v('rooms')),occ=Math.min(100,this.v('occupancy')),hours=Math.max(4,this.v('turnaround')),changes=Math.max(.5,this.v('changes')),safety=this.v('safety')/100,loss=this.v('loss')/100,delay=Math.max(0,hours/24*changes-1),par=Math.max(4,Math.min(8,Math.ceil((3+delay)*(1+safety)))),closet=par-3,inventory=rooms*par,peak=Math.ceil(rooms*occ/100),replacement=Math.ceil(inventory*loss),type=this.querySelector('[data-laundry]').value==='onsite'?this.c.onsite:this.c.offsite,name=this.querySelector('[data-name]').value.trim()||'Your property';this.querySelector('[data-par]').textContent=`${par} PAR`;this.querySelector('[data-hero-par]').textContent=`${par} PAR`;this.querySelector('[data-confidence]').textContent=`${hours}-hour return + ${Math.round(safety*100)}% reserve`;this.querySelector('[data-property]').textContent=name;this.querySelector('[data-meta]').textContent=`${this.f(rooms)} rooms · ${Math.round(occ)}% peak occupancy · ${type}`;this.querySelector('[data-closet-par]').textContent=`${closet} PAR`;['room','laundry','transit'].forEach(k=>this.querySelector(`[data-${k}-sets]`).textContent=`${this.f(rooms)} sets`);this.querySelector('[data-closet-sets]').textContent=`${this.f(rooms*closet)} sets`;this.querySelector('[data-inventory]').textContent=`${this.f(inventory)} sets`;this.querySelector('[data-peak]').textContent=`${this.f(peak)} rooms`;this.querySelector('[data-replacement]').textContent=`${this.f(replacement)} sets`;this.querySelector('[data-explanation]').textContent=closet===1?this.c.four:`${this.c.extraStart} ${closet} ${this.c.extraEnd} ${hours}-hour cycle.`;this.querySelector('[data-comparison]').innerHTML=[4,5,6,7].map(x=>`<tr class="${x===par?'hp-recommended':''}"><td>${x} PAR${x===par?` · ${this.c.recommended}`:''}</td><td>${this.f(rooms*x)}</td><td>${x===par?this.c.best:x<par?`${par-x} ${this.c.below}`:`${x-par} ${this.c.above}`}</td></tr>`).join('');let a=this.querySelector('[data-order]');a.href=`/pages/hotel-towel-linen-order-calculator?par=${par}`;a.textContent=`${this.c.use} ${par} PAR`;return par}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-linen-replacement-planner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotel-linen-replacement-planner')) customElements.define('hotel-linen-replacement-planner', class extends HTMLElement {
    connectedCallback(){
      this.copy=JSON.parse(document.querySelector(`[data-hr-config="${this.dataset.sectionId}"]`).textContent);
      this.items=this.copy.items;
      this.sample={property:this.copy.propertyDefault,rooms:80,par:4,wear:20,loss:8,buffer:10,lead:6,cadence:'3',units:{sheets:2,pillowcases:4,bath_towels:2,hand_towels:2,washcloths:2,bath_mats:1,pool_towels:0},costs:{sheets:18,pillowcases:7,bath_towels:8,hand_towels:4,washcloths:2,bath_mats:5,pool_towels:9}};
      this.form=this.querySelector('[data-form]');
      this.form.addEventListener('submit',e=>{e.preventDefault();this.render();this.status(this.copy.updated)});
      this.form.addEventListener('input',()=>this.render());
      this.form.addEventListener('change',()=>this.render());
      this.querySelector('[data-reset]').addEventListener('click',()=>this.reset());
      this.querySelector('[data-print]').addEventListener('click',()=>this.dispatchEvent(new CustomEvent('havana:print-tool',{bubbles:true})));
      this.render();
    }
    n(selector){return Math.max(0,Number(this.querySelector(selector)?.value)||0)}
    money(value){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(value)}
    number(value){return Math.round(value).toLocaleString(document.documentElement.lang||'en-US')}
    set(name,value){const node=this.querySelector(`[data-${name}]`);if(node)node.textContent=value}
    status(message){const node=this.querySelector('[data-status]');if(node){node.textContent=message;window.setTimeout(()=>{if(node.textContent===message)node.textContent=''},2800)}}
    reset(){
      Object.entries(this.sample).forEach(([key,value])=>{if(typeof value!=='object'){const input=this.querySelector(`[data-input="${key}"]`);if(input)input.value=value}});
      Object.entries(this.sample.units).forEach(([key,value])=>this.querySelector(`[data-units="${key}"]`).value=value);
      Object.entries(this.sample.costs).forEach(([key,value])=>this.querySelector(`[data-cost="${key}"]`).value=value);
      this.render();this.status(this.copy.restored);
    }
    distribute(total,cycles,index){return Math.floor(total*(index+1)/cycles)-Math.floor(total*index/cycles)}
    render(){
      const rooms=Math.max(1,this.n('[data-input="rooms"]')),par=Math.max(1,this.n('[data-input="par"]')),wear=Math.min(100,this.n('[data-input="wear"]'))/100,loss=Math.min(100,this.n('[data-input="loss"]'))/100,buffer=Math.min(100,this.n('[data-input="buffer"]'))/100,lead=Math.min(52,this.n('[data-input="lead"]')),cadence=Math.max(1,this.n('[data-input="cadence"]'));
      const rate=(wear+loss)*(1+buffer), rows=[];let totalCurrent=0,totalAnnual=0,totalBudget=0,totalTrigger=0;
      this.items.forEach(([key,label])=>{
        const units=this.n(`[data-units="${key}"]`),cost=this.n(`[data-cost="${key}"]`),onePar=Math.ceil(rooms*units),current=Math.ceil(onePar*par),annual=Math.ceil(current*rate),trigger=Math.ceil(annual*(lead/52)+onePar*buffer),budget=annual*cost;
        totalCurrent+=current;totalAnnual+=annual;totalBudget+=budget;totalTrigger+=trigger;rows.push({key,label,onePar,current,annual,trigger,budget});
      });
      const body=this.querySelector('[data-line-items]');body.replaceChildren(...rows.map(row=>{const tr=document.createElement('tr');[row.label,this.number(row.onePar),this.number(row.current),this.number(row.annual),this.number(row.trigger),this.money(row.budget)].forEach((value,index)=>{const td=document.createElement('td');td.textContent=value;if(index===0)td.setAttribute('data-label',this.copy.item);tr.append(td)});return tr}));
      const property=this.querySelector('[data-input="property"]').value.trim()||this.copy.propertyDefault;
      this.set('property',property);this.set('current',this.number(totalCurrent));this.set('replacements',this.number(totalAnnual));this.set('annual-pieces',this.number(totalAnnual));this.set('annual-budget',this.money(totalBudget));this.set('monthly-budget',this.money(totalBudget/12));this.set('hero-reserve',this.money(totalBudget/12));
      const cadenceInput=this.querySelector('[data-input="cadence"]');this.set('cadence-label',cadenceInput.selectedOptions[0].textContent.trim());
      const calendar=this.querySelector('[data-calendar]'),today=new Date(),orderMonths=[];for(let month=0;month<12;month+=cadence)orderMonths.push(month);
      const nodes=[];for(let month=0;month<12;month++){
        const date=new Date(today.getFullYear(),today.getMonth()+month,1),cell=document.createElement('div'),name=document.createElement('span'),qty=document.createElement('strong'),cost=document.createElement('small'),cycleIndex=orderMonths.indexOf(month);cell.className='hr-month'+(cycleIndex>-1?' hr-month--order':'');name.textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en-US',{month:'short',year:'2-digit'}).format(date);
        if(cycleIndex>-1){const cycles=orderMonths.length,pieces=this.distribute(totalAnnual,cycles,cycleIndex),spend=this.distribute(Math.round(totalBudget),cycles,cycleIndex);qty.textContent=`${this.number(pieces)} ${this.copy.pieces}`;cost.textContent=this.money(spend)}else{qty.textContent=this.copy.monitor;cost.textContent='—'}
        cell.append(name,qty,cost);nodes.push(cell)
      }calendar.replaceChildren(...nodes);
      this.dataset.totalTrigger=totalTrigger;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-room-turnover-cost-calculator"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('hotel-room-turnover-cost-calculator'))customElements.define('hotel-room-turnover-cost-calculator',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);this.form=this.querySelector('[data-form]');this.form.addEventListener('input',()=>this.calculate());this.form.addEventListener('submit',e=>{e.preventDefault();this.calculate();this.set('status',this.copy.updated)});this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.calculate();this.set('status',this.copy.restored)});this.querySelector('[data-print]').addEventListener('click',()=>this.dispatchEvent(new CustomEvent('havana:print-tool',{bubbles:true})));this.calculate()}v(n){return Math.max(0,Number(this.querySelector(`[data-input="${n}"]`).value)||0)}set(n,v){let el=this.querySelector(`[data-${n}]`);if(el)el.textContent=v}money(n,d=0){return n.toLocaleString('en-US',{style:'currency',currency:'USD',minimumFractionDigits:d,maximumFractionDigits:d})}num(n,d=0){return n.toLocaleString('en-US',{minimumFractionDigits:d,maximumFractionDigits:d})}calculate(){let rooms=Math.max(1,this.v('rooms')),occ=Math.min(100,this.v('occupancy'))/100,days=Math.min(31,Math.max(1,this.v('days'))),checkoutRate=Math.min(100,this.v('checkoutShare'))/100,nights=rooms*occ*days,checkoutRooms=nights*checkoutRate,stayoverRooms=nights-checkoutRooms,checkoutHours=checkoutRooms*this.v('checkoutMinutes')/60,stayoverHours=stayoverRooms*this.v('stayoverMinutes')/60,wage=this.v('wage'),checkoutLabor=checkoutHours*wage,stayoverLabor=stayoverHours*wage,checkoutLaundry=checkoutRooms*this.v('checkoutLaundry'),stayoverLaundry=stayoverRooms*this.v('stayoverLaundry'),checkoutSupplies=checkoutRooms*this.v('checkoutSupplies'),stayoverSupplies=stayoverRooms*this.v('stayoverSupplies'),maintenance=this.v('maintenance'),checkoutMaintenance=nights?maintenance*checkoutRooms/nights:0,stayoverMaintenance=nights?maintenance*stayoverRooms/nights:maintenance,checkoutTotal=checkoutLabor+checkoutLaundry+checkoutSupplies+checkoutMaintenance,stayoverTotal=stayoverLabor+stayoverLaundry+stayoverSupplies+stayoverMaintenance,monthly=checkoutTotal+stayoverTotal,cpor=nights?monthly/nights:0;this.set('hero-cpor',this.money(cpor,2));this.set('cpor',this.money(cpor,2));this.set('total-cpor',this.money(cpor,2));this.set('room-nights',`${this.num(nights)} ${this.copy.roomNights}`);this.set('service-meta',`${this.num(checkoutRooms)} ${this.copy.checkouts} · ${this.num(stayoverRooms)} ${this.copy.stayovers}`);this.set('checkout-rooms',this.num(checkoutRooms));this.set('stayover-rooms',this.num(stayoverRooms));this.set('labor-hours',this.num(checkoutHours+stayoverHours,1));let fields={'checkout-labor':checkoutLabor,'stayover-labor':stayoverLabor,'total-labor':checkoutLabor+stayoverLabor,'checkout-laundry':checkoutLaundry,'stayover-laundry':stayoverLaundry,'total-laundry':checkoutLaundry+stayoverLaundry,'checkout-supplies':checkoutSupplies,'stayover-supplies':stayoverSupplies,'total-supplies':checkoutSupplies+stayoverSupplies,'checkout-maintenance':checkoutMaintenance,'stayover-maintenance':stayoverMaintenance,'total-maintenance':maintenance,'checkout-total':checkoutTotal,'stayover-total':stayoverTotal,'monthly-total':monthly,'monthly-summary':monthly,'annual-total':monthly*12};Object.entries(fields).forEach(([name,amount])=>this.set(name,this.money(amount)));this.set('checkout-cpr',this.money(checkoutRooms?checkoutTotal/checkoutRooms:0,2));this.set('stayover-cpr',this.money(stayoverRooms?stayoverTotal/stayoverRooms:0,2));this.set('empty-note',nights?this.copy.disclaimer:this.copy.empty)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotel-towel-loss-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hotel-towel-loss-calculator')) customElements.define('hotel-towel-loss-calculator', class extends HTMLElement {
    connectedCallback(){this.copy=JSON.parse(document.querySelector(`[data-htl-config="${this.dataset.sectionId}"]`).textContent);this.form=this.querySelector('[data-form]');this.sample={rooms:100,par:4,loss:1.5,recovery:15,contingency:10,lead:6,safety:25,units:{bath:2,hand:2,wash:2,mat:1},costs:{bath:8,hand:3,wash:1.5,mat:5}};this.form.addEventListener('submit',event=>{event.preventDefault();this.render();this.status(this.copy.updated)});this.form.addEventListener('input',()=>this.render());this.querySelector('[data-reset]').addEventListener('click',()=>this.reset());this.querySelector('[data-print]').addEventListener('click',()=>this.dispatchEvent(new CustomEvent('havana:print-tool',{bubbles:true})));this.render()}
    n(selector){return Math.max(0,Number(this.querySelector(selector)?.value)||0)}
    number(value){return Math.ceil(value).toLocaleString(document.documentElement.lang||'en-US')}
    money(value){return new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(value)}
    set(name,value){const node=this.querySelector(`[data-${name}]`);if(node)node.textContent=value}
    status(message){const node=this.querySelector('[data-status]');if(node){node.textContent=message;window.setTimeout(()=>{if(node.textContent===message)node.textContent=''},2800)}}
    reset(){Object.entries(this.sample).forEach(([key,value])=>{if(typeof value!=='object'){const input=this.querySelector(`[data-input="${key}"]`);if(input)input.value=value}});Object.entries(this.sample.units).forEach(([key,value])=>this.querySelector(`[data-units="${key}"]`).value=value);Object.entries(this.sample.costs).forEach(([key,value])=>this.querySelector(`[data-cost="${key}"]`).value=value);this.render();this.status(this.copy.restored)}
    render(){const rooms=Math.max(1,this.n('[data-input="rooms"]')),par=Math.max(1,this.n('[data-input="par"]')),loss=Math.min(25,this.n('[data-input="loss"]'))/100,recovery=Math.min(100,this.n('[data-input="recovery"]'))/100,contingency=Math.min(50,this.n('[data-input="contingency"]'))/100,leadMonths=Math.min(52,this.n('[data-input="lead"]'))/4.345,safety=Math.min(100,this.n('[data-input="safety"]'))/100;let inventory=0,replacements=0,baseCost=0;const rows=[];
      this.copy.items.forEach(([key,label])=>{const itemInventory=rooms*this.n(`[data-units="${key}"]`)*par,net=Math.ceil(itemInventory*loss*12*(1-recovery)),cost=net*this.n(`[data-cost="${key}"]`);inventory+=itemInventory;replacements+=net;baseCost+=cost;rows.push({label,inventory:itemInventory,net,cost})});
      const contingencyCost=baseCost*contingency,annual=baseCost+contingencyCost,monthlyPieces=replacements/12,leadCover=Math.ceil(monthlyPieces*leadMonths),trigger=Math.ceil(leadCover*(1+safety));const body=this.querySelector('[data-rows]');body.replaceChildren(...rows.map(row=>{const tr=document.createElement('tr');[row.label,this.number(row.inventory),this.number(row.net),this.money(row.cost)].forEach(value=>{const td=document.createElement('td');td.textContent=value;tr.append(td)});return tr}));
      this.set('annual-budget',this.money(annual));this.set('program-meta',this.copy.program.replace('[rooms]',this.number(rooms)).replace('[par]',par.toLocaleString(document.documentElement.lang||'en-US')));this.set('rate-meta',this.copy.rate.replace('[loss]',this.n('[data-input="loss"]').toFixed(1)).replace('[recovery]',this.n('[data-input="recovery"]').toFixed(0)));this.set('inventory',this.number(inventory));this.set('replacements',this.number(replacements));this.set('monthly-reserve',this.money(annual/12));this.set('trigger',`${this.number(trigger)} ${this.copy.pieces}`);this.set('lead-cover',`${this.number(leadCover)} ${this.copy.pieces}`);this.set('contingency-cost',this.money(contingencyCost))}
  });

  } catch(e) { console.error(e); }
})();
})();
